export default __webpack_public_path__ + "static/media/Saffron_9781843620181.9af6c725.jpg";